@if (state.initialized && state.referenceQuestion) {
  <as-split
    @appearDisappear
    [direction]="'horizontal'"
    unit="pixel"
    class="h-full"
    [gutterSize]="1"
    [useTransition]="true"
  >
    <as-split-area [size]="'*'" [minSize]="200">
      <exam-detail-view-wrapper>
        <ng-container title>
          <div class="flex items-center justify-between pl-1">
            <span> Reference question #{{ state.referenceQuestion.id }} </span>
            <div class="flex items-center gap-2">
              <dojo-button
                [size]="'xs'"
                [fill]="'outline'"
                [customColor]="'sky'"
                (click)="createSeedQuestion()"
                [matTooltip]="'Create seed'"
                class="ml-auto"
                [pending]="isCreatingSeedQuestion()"
              >
                Create seed
              </dojo-button>
              <dojo-button
                [size]="'xs'"
                [fill]="'outline'"
                [customColor]="'sky'"
                [disabled]="!state.canUndo"
                (click)="undo()"
                [matTooltip]="'Undo'"
                class="ml-auto"
              >
                <dojo-icon icon="undo" />
              </dojo-button>
              <dojo-button
                [size]="'xs'"
                [fill]="'outline'"
                [customColor]="'sky'"
                [disabled]="!state.canRedo"
                (click)="redo()"
                [matTooltip]="'Redo'"
              >
                <dojo-icon icon="redo" />
              </dojo-button>
              <dojo-button [size]="'xs'" [fill]="'outline'" [customColor]="'sky'" dojoJsonEditorTrigger>
                JSON
              </dojo-button>
              <dojo-new-question-item-button />
              <dojo-button
                [size]="'xs'"
                [customColor]="'sky'"
                [disabled]="questionItemsForm.pristine"
                [pending]="isSaving()"
                (click)="saveQuestionItems()"
              >
                <div class="flex items-center gap-1.5">
                  <dojo-icon [icon]="'save'" />
                  <span>Save</span>
                </div>
              </dojo-button>
            </div>
          </div>
        </ng-container>

        <div class="z-3 sticky top-0">
          <div class="bg-neutral-0 flex items-center justify-end gap-1 border-b border-neutral-200 py-1.5 pl-3 pr-4">
            <dojo-icon-button
              [icon]="showPdfViewer() ? 'file-slash' : 'file-pdf'"
              (click)="showPdfViewer.set(!showPdfViewer())"
              [matTooltip]="showPdfViewer() ? 'Close PDF Viewer' : 'Open PDF Viewer'"
            />
            <dojo-icon-button
              [icon]="'crosshairs'"
              (click)="scrollToReferenceQuestion()"
              [matTooltip]="'Scroll to position in the PDF'"
              [disabled]="state.pdfNumber === undefined"
            />
            @if (state.referenceQuestion) {
              <div class="text-xs text-neutral-400">
                Question #<span class="font-bold">{{ state.referenceQuestion.question_number }}</span>
              </div>
            }
          </div>
        </div>
        <div class="scrollbar-gutter-stable overflow-y-auto overflow-x-hidden pl-2">
          <dojo-question-items-editor
            [calculatorAllowed]="state.calculatorAllowed"
            [markCalculationMethod]="state.markCalculationMethod"
            [allowCalculatorEdit]="true"
            (calculatorAllowedChange)="onCalculatorAllowedChange($event)"
          />
        </div>

        <ng-container sidebar>
          <mat-button-toggle-group
            class="custom-toggle-group size-s"
            hideSingleSelectionIndicator
            [value]="sidebarTab()"
            (change)="sidebarTab.set($event.value)"
          >
            <mat-button-toggle [value]="'details'">Details</mat-button-toggle>
            <mat-button-toggle [value]="'questions'">Questions</mat-button-toggle>
          </mat-button-toggle-group>

          <a
            class="flex items-center gap-1 text-sm font-semibold text-sky-500 underline hover:text-sky-600"
            (click)="openHistoryDialog()"
          >
            <dojo-icon [icon]="'timeline'" />
            <span>Open history</span>
          </a>

          <div class="flex flex-1 flex-col gap-4">
            @if (sidebarTab() === 'details') {
              <dojo-reference-question-status-selector [formCtrl]="statusCtrl" [label]="'Status'" [size]="'s'" />

              <div class="custom-mat-form-wrapper">
                <div class="mat-form-label">
                  <span>Source</span>
                </div>

                @if (state.syllabus) {
                  <a
                    [routerLink]="[
                      '/',
                      CmsUrlParts.Syllabus,
                      state.syllabus.slug,
                      CmsUrlParts.Sources,
                      state.referenceQuestion.source_id
                    ]"
                    class="text-sm font-semibold text-sky-500 underline hover:text-sky-600"
                  >
                    {{ state.referenceQuestion.source_id }}
                  </a>
                }
              </div>
            } @else if (sidebarTab() === 'questions') {
              <exam-scoped-question-list [referenceQuestionId]="state.referenceQuestion.id" />
            }
          </div>
        </ng-container>
      </exam-detail-view-wrapper>
    </as-split-area>

    <as-split-area
      class="flex h-full flex-col !overflow-y-hidden"
      [minSize]="280"
      [maxSize]="900"
      [size]="400"
      [visible]="this.activeQuestionItem()"
    >
      <dojo-question-active-item-editor />
    </as-split-area>

    <as-split-area [size]="400" [minSize]="200" class="flex h-full flex-col" [visible]="showPdfViewer()">
      <div
        class="text-primary text-md flex min-h-[45px] shrink-0 flex-wrap items-center justify-between gap-2 border-b border-neutral-200 bg-neutral-50 px-4 font-semibold"
      >
        <span class="whitespace-nowrap">Source</span>

        <mat-button-toggle-group
          class="custom-toggle-group size-s"
          hideSingleSelectionIndicator
          [value]="selectedPdfPlace()"
          (change)="changeSelectedPdfPlace($event.value)"
        >
          <mat-button-toggle [value]="'questions'">Question</mat-button-toggle>
          <mat-button-toggle [value]="'markschemes'">Markscheme</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="h-full overflow-y-auto overflow-x-hidden">
        @if (state.pdfUrls) {
          @for (pdfUrl of state.pdfUrls[selectedPdfPlace()]; track pdfUrl.path) {
            <dojo-pdf-viewer #pdfViewer [src]="pdfUrl.signedUrl" [name]="pdfUrl.path ?? ''" [page]="state.pdfNumber" />
          }
        } @else {
          <div class="flex h-full flex-col items-center justify-center">
            <dojo-loader />
          </div>
        }
      </div>
    </as-split-area>
  </as-split>
} @else if (state.isLoading) {
  <!-- Loading... -->
} @else {
  Given reference question does not exist.
}
